import React, { FC } from "react"
import YouTube from "react-youtube"
import { IframeWrapper, VideoWrapper } from "./styles"
import { VideoProps } from "./types"

const Video: FC<VideoProps> = ({
    youtubeId
}) => {
    return <VideoWrapper>
        <IframeWrapper>
            <YouTube
                videoId={youtubeId}
                // onError={(e) => console.log("error log", e)}
                opts={{
                    height: "calc(100vw * .5625) !important",
                    width: "100%"
                    // playerVars: {
                    //     autoplay: 1
                    // }
                }}
            />
        </IframeWrapper>
    </VideoWrapper>
}

export default Video
